import { Search } from 'lucide-react';
import type { InputHTMLAttributes } from 'react';

export type GlobalSearchProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'className' | 'type'>;

/** The affordance in a page hero, aligned with the greeting. Presentational —
 * a controlled input, so callers own the query state and what it searches. */
export function GlobalSearch(props: GlobalSearchProps) {
  return (
    <search className="flex h-9 w-56 items-center gap-2 rounded-lg border border-input bg-card px-3 text-sm text-muted-foreground shadow-xs focus-within:border-ring focus-within:ring-[3px] focus-within:ring-ring/50 focus-within:ring-offset-2 focus-within:ring-offset-background sm:w-72">
      <label htmlFor="global-search" className="sr-only">
        Search
      </label>
      <Search aria-hidden="true" className="h-4 w-4 shrink-0" />
      <input
        id="global-search"
        aria-label="Search"
        placeholder="Search anything..."
        {...props}
        type="text"
        className="w-full bg-transparent text-sm text-foreground outline-none placeholder:text-muted-foreground"
      />
    </search>
  );
}
